import React from 'react';
interface CTAButtonProps {
  text: string;
  className?: string;
  isMain?: boolean;
}
export function CTAButton({
  text,
  className = '',
  isMain = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (isMain) {
      window.location.href = 'https://mentecheck.librosdigitales.pro/cart/46849998749835:1';
    } else {
      const checkoutSection = document.getElementById('checkout');
      if (checkoutSection) {
        checkoutSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`w-full md:w-auto bg-teal-600 hover:bg-teal-700 text-white font-bold py-4 px-8 rounded-xl text-lg md:text-xl transition-all duration-300 transform hover:scale-105 animate-pulse-glow shadow-lg ${className}`} data-id="element-73">
      {text}
    </button>;
}